import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { emailRegex, FormState } from '@opu/utils';
import { useHistory, useLocation } from 'react-router-dom';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';

const useForm = () => {
  let history = useHistory();
  let location = useLocation();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);

  const [establishments, setEstablishments] = useState([]);
  useEffect(() => {
    if (location.params && location.params.id) {
      getContract();
      // getEstablishments();
    } else {
      history.push('/contract');
    }
  }, []);

  const back = () => {
    history.goBack();
  };

  const getEstablishments = () => {
    setLoading(true);
    AxiosInstance.get('/establishment')
      .then((res) => {
        setEstablishments(res.data.items);
      })
      .catch((error) => {
        Swal.fire(t('establishment.ERROR_GET_ESTABLISHMENT'), '', 'error');
      })
      .finally(() => setLoading(false));
  };

  const formatDate = (date) => {
    date = new Date(date);
    var dd = date.getDate();

    var mm = date.getMonth() + 1;
    var yyyy = date.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    return `${yyyy}-${mm}-${dd}`;
  };

  const getContract = () => {
    setLoading(true);
    AxiosInstance.get('/contract/' + location.params.id)
      .then((response) => {
        let inputValues = {
          contractStartDate: formatDate(response.data.contractStartDate),
          contractEndDate: formatDate(response.data.contractEndDate),
          status: response.data.status,
        };
        updateFormState(inputValues);
      })
      .catch((error) => {
        Swal.fire(t('contract.ERROR_GET_CONTRACT'), '', 'error');
        history.push('/contract');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateContract = () => {
    setLoading(true);

    AxiosInstance.patch(`/contract/${location.params.id}`, {
      contractStartDate: formState.inputValues.contractStartDate,
      contractEndDate: formState.inputValues.contractEndDate,
      status: formState.inputValues.status,
    })
      .then((response) => {
        updateFormState({
          status: response.data.status,
        });
        Swal.fire(t('contract.SUCCESS_UPDATE_CONTRACT'), '', 'success');
      })
      .catch((error) => {
        if (error.status === 400) {
          handleErrorsServer(error.data.message);
          if (
            error.data.message.includes('ERROR_START_DATE_OVERLAP') ||
            error.data.message.includes('ERROR_CONTRACT_DATE_EXPIRED') ||
            error.data.message.includes('ERROR_CONTRACT_OUT_DATE_RANG')
          ) {
            Swal.fire(t(`contract.${error.data.message[0]}`), '', 'error');
          }
        } else Swal.fire(t('contract.ERROR_UPDATE_CONTRACT'), '', 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const inputValues = {
    contractStartDate: { value: '', validate: { required: true } },
    contractEndDate: { value: '', validate: { required: true } },
    status: { value: '', validate: { required: true } },
    establishment: { value: '', validate: { required: true } },
  };

  const { formState, submitHandler, handleErrorsServer, updateFormState, field } = FormState(inputValues, updateContract);

  return {
    submitHandler,
    back,
    loading,
    field,
    establishments,
  };
};

export default useForm;
